export const calendarMixin = {
  computed: {
    allowedDates() {
      return (date) => {
        const day = new Date(date).getDay();
        return day !== 5 && day !== 6;
      };
    },
  },
};
